import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { withSetPropAction } from "mobx-stores/_extension/with-set-props";
import { Base } from "../base";
import { Customer } from "../customers/customer";
import { Order } from "../orders/order";
import { WorkOrderPo } from "../work-order-po/work-order-po";
import { WorkOrder } from "../work-order/work-order";
import {
  IAddPackingNoteItem,
  IUpdatePackingNoteItem,
  PackingNoteItem,
} from "./packing-note-item";

export const PackingNote = types
  .compose(
    Base,
    types.model({
      orderNumber: types.maybeNull(types.number),
      date: types.maybeNull(types.string),
      number: types.maybeNull(types.string),
      workOrderId: types.maybeNull(types.string),
      workOrder: types.maybeNull(WorkOrder),
      workOrderPOId: types.maybeNull(types.string),
      workOrderPO: types.maybeNull(WorkOrderPo),
      purchaseOrderId: types.maybeNull(types.string),
      purchaseOrder: types.maybeNull(Order),
      customerId: types.maybeNull(types.string),
      customer: types.maybeNull(Customer),
      kcsPackage: types.maybeNull(types.string),
      kcsTest: types.maybeNull(types.string),
      items: types.optional(types.array(PackingNoteItem), []),
    })
  )
  .actions(withSetPropAction);
export interface IPackingNote extends Instance<typeof PackingNote> {}
export interface IPackingNoteProperties
  extends SnapshotIn<typeof PackingNote> {}

export interface IAddUpdatePackingNote
  extends Pick<
    IPackingNoteProperties,
    | "date"
    | "number"
    | "purchaseOrderId"
    | "customerId"
    | "workOrderPOId"
    | "kcsPackage"
    | "kcsTest"
  > {}

export interface IAddPackingNote extends IAddUpdatePackingNote {
  items: IAddPackingNoteItem[];
}

export interface IUpdatePackingNote
  extends IAddUpdatePackingNote,
    Pick<IPackingNoteProperties, "workOrderId" | "id"> {
  items: IUpdatePackingNoteItem[];
}
